
import storage from "redux-persist/lib/storage";
import { PersistConfig } from "redux-persist";
import type { RootState } from "@/AppRedux/reducers";

const persistConfig: PersistConfig<RootState> = {
  key: "root",
  storage,
  version: 1,
  whitelist: ["booking", "theme", "paymentBeam" ,"hotelProfile","auth"], // เพิ่ม paymentBeam ใน whitelist
};

export default persistConfig;
